import React, { useContext, useEffect, useRef, useState } from "react";
import "./style.scss";
import SquarePlus from "../../../assets/HomePage/SquarePlus.svg";
import ViewIcon from "../../../assets/Header/viewIcon.svg";
import DeleteIcon from "../../../assets/Header/deleteIcon.svg";
import EditIcon from "../../../assets/Header/editIcon.svg";
import { Empty, message, Modal, Tooltip } from "antd";
import AddCategory from "../AddCategory";
import SearchIcon from "../../../assets/CreateCategory/SeachIcon.svg";
import FilterIcon from "../../../assets/HomePage/filterIcon.svg";
import Button from "../../../common/Button";
import {
  useCreateDuplicateAngleSet,
  useDeleteAngleSet,
  useGetAllMarketPlace,
  useGetAllMarketPlaceCategories,
  useGetAllMarketPlaceSubCategories,
  useGetAllMergedGuidelines,
} from "../../../hooks/useGuidelines";
import AddSubCategory from "../AddSubCategory";
import CreateMarketplace from "../../Seggregation/CreateMarketplace";
import { GuidelinesSelectedCategoryContext } from "../../../context/guidelinesProvider";
import { useNavigate, useSearchParams } from "react-router-dom";
import DebouncedInput from "../../../common/DebounceInput";
import ClientsList from "../ClientsList";
import CreationRequest from "../../CreateRequest/CreationRequest";
import { useTour } from "@reactour/tour";
import SequentialDetail from "../SequentialDetail";
import { CopyOutlined } from "@ant-design/icons";

const GuidelinesList = () => {
  const [categoryList, setCategoryList] = useState([]);
  const [angleSets, setAngleSets] = useState([]);
  const [isCreateMarketplace, setIsCreateMarketplace] = useState(false);
  const [marketPlaceSubCategoryList, setMarketPlaceSubCategoryList] = useState(
    []
  );
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [isAddCategory, setIsAddCategory] = useState(false);
  const [isAddSubCategory, setIsAddSubCategory] = useState(false);
  const [isCreateCategory, setIsCreateCategory] = useState(false);
  const [isCreateSubCategory, setIsCreateSubCategory] = useState(false);
  const [activeSubCategoryItem, setActiveSubCategoryItem] = useState();
  const [marketPlaceList, setMarketPlaceList] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [searchSubCategoryName, setSearchSubCategoryName] = useState("");
  const [searchMarketPlace, setSearchMarketPlace] = useState("");
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [selectedAngleSetId, setSelectedAngleSetId] = useState("");
  const [isAngleSetDetails, setIsAngleSetDetails] = useState(false);
  const [angleSetDetails, setAngleSetDetails] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const {
    guide_setSelectedCategoryName,
    guide_setSelectedSubCategoryName,
    guide_selectedCategoryId,
    guide_setSelectedCategoryId,
    guide_selectedSubCategoryId,
    guide_setSelectedSubCategoryId,
    guide_setSelectedMarketPlaceName,
    guide_selectedMarketPlaceId,
    guide_setSelectedMarketPlaceId,
    guide_setSelectedGuidelLineId,
    guide_selectedGuidelLineId,
    guide_selectedClientId,
    guide_selectedClientName,
    guide_selectedRequestId,
    guide_setSelectedRequestId,
  } = useContext(GuidelinesSelectedCategoryContext);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalText, setModalText] = useState(
    "Are you sure? You want to Delete the Angle Set."
  );

  const navigate = useNavigate();
  const selectedCatgeoryRef = useRef(null);
  const selectedMarketPlaceRef = useRef(null);
  const selectedAllMarketPlaceRef = useRef(null);
  const clientRef = useRef(null);

  const [showClients, setShowClients] = useState(false);
  const [request, setRequest] = useState(false);
  const [client, setClient] = useState("");

  const [searchParams] = useSearchParams();
  const { setIsOpen } = useTour();

  useEffect(() => {
    const clientName = searchParams.get("clientName");
    const requestId = searchParams.get("requestId");
    setClient(clientName);
    guide_setSelectedRequestId(requestId);
  }, [searchParams]);
  useEffect(() => {
    setIsOpen(true);
  }, []);
  useEffect(() => {
    if (selectedCatgeoryRef.current) {
      selectedCatgeoryRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if (selectedMarketPlaceRef.current) {
      selectedMarketPlaceRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if (selectedAllMarketPlaceRef.current) {
      selectedAllMarketPlaceRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if (clientRef.current) {
      clientRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [
    guide_selectedCategoryId,
    guide_selectedSubCategoryId,
    guide_selectedMarketPlaceId,
  ]);

  useEffect(() => {
    if (marketPlaceList.length > 0) {
      const initialCategory = marketPlaceList[0];
      guide_setSelectedMarketPlaceId(initialCategory?._id);
      guide_setSelectedMarketPlaceName(initialCategory?.name);
    }
  }, [marketPlaceList]);
  const onSuccessGetAllCategories = (data) => {
    setCategoryList(data?.data?.data);
  };
  const onErrorGetAllCategories = () => {};

  const { data: getCategories, refetch: refetchList } =
    useGetAllMarketPlaceCategories(
      "getCategories",
      guide_selectedMarketPlaceId,
      guide_selectedClientId,
      onSuccessGetAllCategories,
      onErrorGetAllCategories
    );

  const onSuccessGetAllMarketPlaceSubCategories = (data) => {
    setMarketPlaceSubCategoryList(data?.data?.data);
  };
  const onErrorGetAllMarketPlaceSubCategories = () => {};

  const { data: getSubCategories, refetch: refetchMarketPlaceSubCategories } =
    useGetAllMarketPlaceSubCategories(
      "getSubCategories",
      guide_selectedCategoryId,
      guide_selectedMarketPlaceId,
      guide_selectedClientId,
      onSuccessGetAllMarketPlaceSubCategories,
      onErrorGetAllMarketPlaceSubCategories
    );

  const onSuccessGetAllMergedGuidelines = (res) => {
    if (res) {
      setAngleSets(res?.data?.data?.angleSets);
      guide_setSelectedGuidelLineId(res?.data?.data?._id);
    }
  };
  const onErrorGetAllMergedGuidelines = () => {};
  const { data: getMergedGuideline, refetch: refetchGuidelines } =
    useGetAllMergedGuidelines(
      "getCategories",
      guide_selectedCategoryId,
      guide_selectedSubCategoryId,
      guide_selectedMarketPlaceId,
      onSuccessGetAllMergedGuidelines,
      onErrorGetAllMergedGuidelines
    );

  const onSuccessGetAllMarketPlace = (data) => {
    setMarketPlaceList(data?.data?.data);
  };

  const onErrorGetAllMarketPlace = (err) => {
    console.log(err.message);
  };

  const { data: getAllMarketPlace, refetch: refetchMarketPlaceList } =
    useGetAllMarketPlace(
      "getAllSubCategories",
      guide_selectedClientId,
      pageNum,
      pageSize,
      onSuccessGetAllMarketPlace,
      onErrorGetAllMarketPlace
    );

  const onSuccessDeleteAngleSet = (res) => {
    if (res.status === 200) {
      message.success("Angle Set Deleted");
      setShowDeleteModal(false);
      refetchGuidelines();
    }
  };
  const onErrorDeleteAngleSet = () => {};

  const { mutate: deleteAngle } = useDeleteAngleSet(
    onSuccessDeleteAngleSet,
    onErrorDeleteAngleSet
  );

  const onSuccessDuplicate = (res) => {
    if (res.status === 200) {
      message.success("Duplicate Angle Set Deleted");
      setShowConfirmModal(false);
      refetchGuidelines();
    }
  };
  const onErrorDuplicate = () => {};
  const { mutate: createDuplicate } = useCreateDuplicateAngleSet(
    onSuccessDuplicate,
    onErrorDuplicate
  );
  const marketPlaceCreaetd = () => {
    setIsCreateMarketplace(false);
    refetchMarketPlaceList();
  };

  const subCategoryAddedToMarketPlace = () => {
    setIsAddSubCategory(false);
    refetchMarketPlaceSubCategories();
  };

  const categoryAddedToMarketPlace = () => {
    setIsAddCategory(false);
    refetchList();
  };

  const truncateText = (text, maxLength) => {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const getAngleSetDetailsModal = () => {
    return (
      <Modal
        title="Angles Set Details"
        open={isAngleSetDetails}
        footer={null}
        width="90%"
        height="90dvh"
        className="angle_set_details_modal_wrapper"
        onCancel={() => setIsAngleSetDetails(false)}
      >
        {/* <AngleSetDetails imageData={angleSetDetails} /> */}
        <SequentialDetail isDisabled={true} imageData={angleSetDetails} />
      </Modal>
    );
  };
  const getAddCategoryModal = () => {
    return (
      <Modal
        title="Add Category"
        open={isAddCategory}
        footer={null}
        width="85%"
        height="100dvh"
        className="add_category_modal_wrapper"
        onCancel={() => setIsAddCategory(false)}
      >
        <AddCategory
          isCreateCategory={isCreateCategory}
          setIsCreateCategory={setIsCreateCategory}
          guide_selectedMarketPlaceId={guide_selectedMarketPlaceId}
          setIsAddCategory={setIsAddCategory}
          isCatgeoryAdded={categoryAddedToMarketPlace}
          categoryList={categoryList}
        />
      </Modal>
    );
  };

  const getAddSubCategoryModal = () => {
    return (
      <Modal
        title="Add Sub Category"
        open={isAddSubCategory}
        footer={null}
        width="85%"
        height="100dvh"
        className="add_sub_category_modal_wrapper"
        onCancel={() => setIsAddSubCategory(false)}
      >
        <AddSubCategory
          isCreateSubCategory={isCreateSubCategory}
          setIsCreateSubCategory={setIsCreateSubCategory}
          setIsAddSubCategory={setIsAddSubCategory}
          activeSubCategoryItem={activeSubCategoryItem}
          setActiveSubCategoryItem={setActiveSubCategoryItem}
          guide_selectedCategoryId={guide_selectedCategoryId}
          guide_selectedMarketPlaceId={guide_selectedMarketPlaceId}
          isSubCategoryAdded={subCategoryAddedToMarketPlace}
          marketPlaceSubCategoryList={marketPlaceSubCategoryList}
        />
      </Modal>
    );
  };
  const getCreateMarketplaceModal = () => {
    return (
      <Modal
        title="Create Marketplace"
        open={isCreateMarketplace}
        footer={null}
        width="60%"
        height="90dvh"
        className="create_marketplace_modal_wrapper"
        onCancel={() => setIsCreateMarketplace(false)}
      >
        <CreateMarketplace
          isMarketPlaceCreated={marketPlaceCreaetd}
          setIsCreateMarketplace={setIsCreateMarketplace}
        />
      </Modal>
    );
  };

  const getCategory = () => {
    return (
      <div className="category_wrapper third-step">
        <div className="title">
          <h6>Category</h6>
          <div className="square_plus_wrapper">
            <img
              src={SquarePlus}
              alt="SquarePlus"
              onClick={() => setIsAddCategory(true)}
            />
          </div>
        </div>
        <div className="search_wrapper">
          <DebouncedInput
            searchName={searchName}
            setSearchName={setSearchName}
            placeholder={"Search"}
            allowClear={true}
            showSearch={true}
          />
          <div className="searchIcon_wrapper">
            <img src={SearchIcon} alt="searchIcon" />
          </div>
        </div>
        <div className="list">
          {categoryList?.length > 0 &&
            categoryList
              .filter((item) => {
                if (!searchName?.trim()) {
                  return true;
                }
                const regex = new RegExp(
                  `\\b${searchName.toLowerCase()}\\b`,
                  "i"
                );
                return (
                  item?.name
                    ?.toLowerCase()
                    .includes(searchName.toLowerCase()) ||
                  regex.test(item?.name?.toLowerCase())
                );
              })
              .map((category, index) => {
                const isSelected = guide_selectedCategoryId === category._id;
                return (
                  <button
                    className={`categoryBtn ${
                      isSelected ? "activeCategory" : ""
                    }`}
                    key={index}
                    ref={isSelected ? selectedCatgeoryRef : null}
                    onClick={() => {
                      if (!isSelected) {
                        guide_setSelectedCategoryId(category?._id);
                        guide_setSelectedCategoryName(category?.name);
                        guide_setSelectedSubCategoryId("");
                        guide_setSelectedSubCategoryName("");
                        setAngleSets([]);
                      }
                    }}
                  >
                    {/* <div className="image_wrapper_box">
                      <img src={category?.image?.thumbPath?.url} alt="" />
                    </div> */}
                    <div className="text_wrapper">
                      {category?.name?.length > 15 ? (
                        <Tooltip title={category?.name} placement="rightTop">
                          {truncateText(category?.name, 15)}
                        </Tooltip>
                      ) : (
                        category?.name
                      )}
                    </div>
                  </button>
                );
              })}
        </div>
      </div>
    );
  };
  const getSubCategory = () => {
    return (
      <div className="subCategory_wrapper forth-step">
        <div className="title">
          <h6>Sub Category</h6>
          {/* <button> +</button> */}
          <div
            className={`square_plus_wrapper ${
              !guide_selectedCategoryId ? "disabled" : ""
            }`}
          >
            <img
              src={SquarePlus}
              alt="SquarePlus"
              onClick={() => setIsAddSubCategory(true)}
            />
          </div>
        </div>
        <div className="search_wrapper">
          <DebouncedInput
            searchName={searchSubCategoryName}
            setSearchName={setSearchSubCategoryName}
            placeholder={"Search"}
            allowClear={true}
            showSearch={true}
          />
          <div className="searchIcon_wrapper">
            <img src={SearchIcon} alt="searchIcon" />
          </div>
        </div>
        <div className="list">
          {marketPlaceSubCategoryList?.length > 0 &&
          guide_selectedCategoryId ? (
            marketPlaceSubCategoryList
              ?.filter((item) => {
                if (!searchSubCategoryName?.trim()) {
                  return true;
                }
                const regex = new RegExp(
                  `\\b${searchSubCategoryName.toLowerCase()}\\b`,
                  "i"
                );
                return (
                  item?.name
                    ?.toLowerCase()
                    .includes(searchSubCategoryName.toLowerCase()) ||
                  regex.test(item?.name?.toLowerCase())
                );
              })
              .map((item, index) => {
                return (
                  <button
                    className={`categoryBtn ${
                      guide_selectedSubCategoryId === item._id
                        ? "activeCategory"
                        : ""
                    }`}
                    key={index}
                    ref={
                      item._id === guide_selectedSubCategoryId
                        ? selectedMarketPlaceRef
                        : null
                    }
                    onClick={() => {
                      guide_setSelectedSubCategoryName(item.name);
                      guide_setSelectedSubCategoryId(item._id);
                    }}
                  >
                    {/* <div className="image_wrapper_box">
                      <img src={item?.image?.thumbPath?.url} alt="" />
                    </div> */}
                    <div className="text_wrapper">
                      {item?.name?.length > 15 ? (
                        <Tooltip title={item?.name} placement="rightTop">
                          {truncateText(item?.name, 15)}
                        </Tooltip>
                      ) : (
                        item?.name
                      )}
                    </div>
                  </button>
                );
              })
          ) : marketPlaceSubCategoryList?.length === 0 &&
            guide_selectedCategoryId ? (
            <Empty description={"Click Plus Icon to add Sub Category"} />
          ) : (
            !guide_selectedCategoryId && (
              <Empty
                description={"Select a category to view its subcategories"}
              />
            )
          )}
        </div>
      </div>
    );
  };

  const handleOk = () => {
    let payload = {
      guidelineId: guide_selectedGuidelLineId,
      angleSetId: selectedAngleSetId,
      orgId: null,
    };
    deleteAngle(payload);
  };
  const handleConfirmOk = () => {
    let payload = {
      guidelineId: guide_selectedGuidelLineId,
      angleSetId: selectedAngleSetId,
      orgId: null,
    };
    createDuplicate(payload);
  };
  const handleCancel = () => {
    setShowDeleteModal(false);
    setShowConfirmModal(false);
  };

  const getDeleteModal = () => {
    return (
      <Modal
        title="Delete Angle Set"
        open={showDeleteModal}
        onOk={() => handleOk()}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        className="delete_modal"
        centered
      >
        <p>{modalText}</p>
      </Modal>
    );
  };
  const getConfirmationModal = () => {
    return (
      <Modal
        title="Confirmation"
        open={showConfirmModal}
        onOk={() => handleConfirmOk()}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        className="confirm_modal"
        centered
      >
        <p>{"Do you want to create a duplicate of selected angle set?"}</p>
      </Modal>
    );
  };
  const handleClient = () => {
    if (guide_selectedClientName === "") {
      return "Default";
    } else if (guide_selectedRequestId) {
      return client;
    } else {
      return guide_selectedClientName;
    }
  };

  const getClientsModal = () => {
    return (
      <Modal
        title="Clients"
        centered
        open={showClients}
        footer={null}
        width="60%"
        height="90dvh"
        className="create_marketplace_modal_wrapper"
        onCancel={() => setShowClients(false)}
      >
        <ClientsList setShowClients={setShowClients} />
      </Modal>
    );
  };

  const getRequestModal = () => {
    return (
      <Modal
        title="Guideline Request"
        open={request}
        footer={null}
        width="100%"
        height="70dvh"
        className="create_marketplace_modal_wrapper"
        onCancel={() => setRequest(false)}
      >
        <CreationRequest />
      </Modal>
    );
  };

  const getSetsList = () => {
    return (
      <div className="sets_main_wrapper fifth-step">
        <div className="sets_content">
          <div className="btnAction_wrapper">
            <Button
              width="150px"
              height="40px"
              text="Create New Set"
              isDisabled={
                guide_selectedCategoryId && guide_selectedSubCategoryId
                  ? false
                  : true
              }
              handleClick={() => navigate("/create-set")}
            />
          </div>
          <div className="sets_main_container">
            {angleSets?.length > 0 ? (
              angleSets?.map((item, index) => {
                return (
                  <div className="sets_card_wrapper" key={index}>
                    <div className="sets_card_content">
                      <div className="sets_header">
                        <div className="title">
                          Set {index + 1} ({item?.angles?.length}{" "}
                          {item?.angles?.length === 1 ? "Image" : "Images"})
                        </div>

                        <div className="action_wrapper">
                          <div className="clone_icon_wrapper">
                            <Tooltip title="Clone">
                              <CopyOutlined
                                onClick={() => {
                                  setShowConfirmModal(true);
                                  setSelectedAngleSetId(item?._id);
                                }}
                              />
                            </Tooltip>
                          </div>

                          <div className="view_icon_wrapper">
                            <Tooltip title="View">
                              <img
                                src={ViewIcon}
                                alt="ViewIcon"
                                onClick={() => {
                                  setIsAngleSetDetails(true);
                                  setAngleSetDetails(item.angles);
                                }}
                              />
                            </Tooltip>
                          </div>

                          <div className="edit_icon_wrapper">
                            <Tooltip title="Edit">
                              <img
                                src={EditIcon}
                                alt="EditIcon"
                                onClick={() =>
                                  navigate(
                                    `/update-set/${guide_selectedGuidelLineId}/${item._id}`
                                  )
                                }
                              />
                            </Tooltip>
                          </div>

                          <div className="delete_icon_wrapper">
                            <Tooltip title="Delete">
                              <img
                                src={DeleteIcon}
                                alt="deleteIconWrapper"
                                onClick={() => {
                                  setShowDeleteModal(true);
                                  setSelectedAngleSetId(item?._id);
                                }}
                              />
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                      <div className="sets_images_list">
                        {item?.angles?.length > 0 &&
                          item?.angles.map((angle, index) => {
                            return (
                              <div className="image_wrapper" key={index}>
                                <div className="shoot_type_wrapper">
                                  {angle?.angleGlobal?.shootType}
                                </div>
                                <div className="image_container">
                                  <img
                                    src={
                                      angle?.angleGlobal?.image?.thumbPath?.url
                                    }
                                    alt=""
                                  />
                                </div>
                                <span>{angle?.angleGlobal?.name}</span>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : !guide_selectedCategoryId && !guide_selectedSubCategoryId ? (
              <div className="empty_container">
                <Empty
                  description={
                    "Select a category and subcategory to view the angle set."
                  }
                />
              </div>
            ) : guide_selectedCategoryId && guide_selectedSubCategoryId ? (
              <div className="empty_container">
                <Empty
                  description={
                    "No angle sets found create a new set to view here"
                  }
                />
              </div>
            ) : (
              guide_selectedCategoryId &&
              !guide_selectedSubCategoryId && (
                <div className="empty_container">
                  <Empty
                    description={
                      "Select a subcategory to view the angle sets here"
                    }
                  />
                </div>
              )
            )}
          </div>
        </div>
      </div>
    );
  };
  const getClientSection = () => {
    return (
      <div className="client_container first-step" ref={clientRef}>
        <div className="title2">
          <h6>Client</h6>
          {guide_selectedRequestId?.length > 0 ? (
            <div className="square_plus_wrapper disabled">
              <img src={FilterIcon} alt="filterIcon" />
            </div>
          ) : (
            <div
              className="square_plus_wrapper"
              onClick={() => setShowClients(true)}
            >
              <img src={FilterIcon} alt="filterIcon" />
            </div>
          )}
        </div>
        <div className="list">
          <button className="categoryBtnActive">{handleClient()}</button>
        </div>
      </div>
    );
  };

  const getMarketPlaceSection = () => {
    return (
      <div className="market_place_container second-step">
        <div className="title">
          <h6>Marketplace</h6>
          {client?.length > 0 ? (
            <div className="square_plus_wrapper disabled">
              <img src={SquarePlus} alt="SquarePlus" />
            </div>
          ) : (
            <div className="square_plus_wrapper">
              <img
                src={SquarePlus}
                alt="SquarePlus"
                onClick={() => setIsCreateMarketplace(true)}
              />
            </div>
          )}
        </div>
        <div className="search_wrapper">
          <DebouncedInput
            searchName={searchMarketPlace}
            setSearchName={setSearchMarketPlace}
            placeholder={"Search"}
            allowClear={true}
            showSearch={true}
          />
          {/* <input className="searchInput" placeholder="Search" /> */}
          <div className="searchIcon_wrapper">
            <img src={SearchIcon} alt="searchIcon" />
          </div>
        </div>
        <div className="list">
          {marketPlaceList
            .filter((item) => {
              if (!searchMarketPlace?.trim()) {
                return true;
              }
              const regex = new RegExp(
                `\\b${searchMarketPlace.toLowerCase()}\\b`,
                "i"
              );
              return (
                item?.name
                  ?.toLowerCase()
                  .includes(searchMarketPlace.toLowerCase()) ||
                regex.test(item?.name?.toLowerCase())
              );
            })
            .map((category, index) => {
              return (
                <button
                  className={`categoryBtn ${
                    guide_selectedMarketPlaceId === category._id
                      ? "activeCategory"
                      : ""
                  }`}
                  key={index}
                  ref={
                    category._id === guide_selectedMarketPlaceId
                      ? selectedAllMarketPlaceRef
                      : null
                  }
                  onClick={() => {
                    guide_setSelectedMarketPlaceId(category?._id);
                    guide_setSelectedMarketPlaceName(category?.name);
                    guide_setSelectedCategoryId("");
                    guide_setSelectedCategoryName("");
                    guide_setSelectedSubCategoryId("");
                    guide_setSelectedSubCategoryName("");
                    setAngleSets([]);
                  }}
                >
                  {category.name}
                </button>
              );
            })}
        </div>
      </div>
    );
  };

  return (
    <div className="home_main_container">
      <div className="col_one">
        {getClientSection()}
        {getMarketPlaceSection()}
      </div>
      <div className="col_two">
        {getCategory()}
        {getSubCategory()}
      </div>
      <div className="col_three">{getSetsList()}</div>
      {isAddCategory && getAddCategoryModal()}
      {isAddSubCategory && getAddSubCategoryModal()}
      {isCreateMarketplace && getCreateMarketplaceModal()}
      {showDeleteModal && getDeleteModal()}
      {isAngleSetDetails && getAngleSetDetailsModal()}
      {showClients && getClientsModal()}
      {request && getRequestModal()}
      {showConfirmModal && getConfirmationModal()}
    </div>
  );
};
export default GuidelinesList;
